module.exports = __webpack_public_path__ + "img/6d464069f3ce6c83d4e51a33736817f0.jpg";